import React from "react";
import { Tooltip } from "react-bootstrap";

// The only way to hide Tooltip if there is no text is to return empty div as null will not wotk in Overlay
export const getTooltipWithText = text => {
  return text && text !== '' ? /*#__PURE__*/React.createElement(Tooltip, null, text) : /*#__PURE__*/React.createElement("div", null);
};